import { memo, useMemo } from 'react'
import { List } from '@mui/material'
import { menuItems } from './sidebar-constants.jsx'
import { SidebarMenuItem } from './sidebar-menu-item'

export const SidebarMenu = memo(({ layoutExpanded, buildUrl, handleClick, features, location }) => {
  const visibleItems = useMemo(
    () =>
      menuItems.filter((item) => {
        if (!item.requires) return true
        if (item.optOut) return features[item.requires]
        return Boolean(features[item.requires])
      }),
    [features],
  )

  return (
    <List sx={{ flex: 1 }}>
      {visibleItems.map((item) => (
        <SidebarMenuItem
          key={item.text}
          item={item}
          layoutExpanded={layoutExpanded}
          buildUrl={buildUrl}
          handleClick={handleClick}
          isSelected={location.pathname === item.path}
        />
      ))}
    </List>
  )
})
